/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Set material</h4>

<p>Set the material for the selected faces, or for all faces if none are selected.</p>`;

export default function ShowMaterialsTooltip() {
    return h('div', { innerHTML: body });
}
